import { takeLatest } from 'redux-saga/effects';

import * as hellosignActions from '../actions';
import {
    fetchPdfAndSigningUrlSaga,
    fetchPdfUrlSaga,
    fetchSigningUrlSaga,
    loadSigningIframeSaga,
    validateTokenSaga,
} from './signingUrl';

/**
 * Root saga for `hellosign`
 * Triggers sagas related to all hellosign actions
 *
 * @method hellosignSaga
 * @type {Generator}
 */
function* hellosignSaga() {
    // Fetch the signing URL for the given token.
    yield takeLatest(hellosignActions.fetchSigningUrl.TRIGGER, fetchSigningUrlSaga);
    // Fetch the PDF Blob and the HelloSign signing URL for the given token.
    yield takeLatest(hellosignActions.fetchPdfAndSigningUrl.TRIGGER, fetchPdfAndSigningUrlSaga);
    // Fetch the handbook pdf url for downloading.
    yield takeLatest(hellosignActions.fetchPdfUrl.TRIGGER, fetchPdfUrlSaga);
    // Fetch the validated token
    yield takeLatest(hellosignActions.validateToken.TRIGGER, validateTokenSaga);
    // Fetch the signing and PDF url for the HelloSign document (via token).
    yield takeLatest(hellosignActions.loadSigningIframe.TRIGGER, loadSigningIframeSaga);
}

export default hellosignSaga;
